module.exports = __webpack_public_path__ + "img/Master.55cd2440.png";